'use client'

import { Button } from '@/components/button'
import { Container } from '@/components/container'
import { Gradient } from '@/components/gradient'
import { MotionDiv } from '@/components/motion-wrapper'

export function Hero() {
  return (
    <div className="relative overflow-hidden">
      <Gradient className="absolute inset-2 bottom-0 rounded-4xl ring-1 ring-black/5 ring-inset" />
      <Container className="relative">
        <div className="pt-16 pb-24 sm:pt-24 sm:pb-32 md:pt-32 md:pb-48">
          <MotionDiv
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="font-display text-5xl/[1.1] font-medium tracking-tight text-balance text-gray-950 sm:text-7xl/[1] md:text-8xl/[1]">
              Build Faster. Scale Smarter. Launch Better.
            </h1>
            <p className="mt-8 max-w-2xl text-xl/7 font-medium text-gray-950/75 sm:text-2xl/8">
              From concept to deployment, we help you design, build, and grow products with strong engineering and clear product thinking.
            </p>
            <div className="mt-12 flex flex-col gap-x-6 gap-y-4 sm:flex-row">
              <Button 
                data-cal-namespace="15min"
                data-cal-link="mohammed-saket-d4virq/15min"
                data-cal-config='{"layout":"month_view"}'
                onClick={() => {
                  if (typeof window !== 'undefined' && window.gtag) {
                    window.gtag('event', 'cta_clicked', {
                      event_category: 'engagement',
                      event_label: 'book_consultation_hero',
                      value: 1,
                    })
                  }
                }}
              >
                Book a Free Consultation
              </Button>
              <Button 
                variant="secondary" 
                href="/services"
                className="bg-white text-gray-900 hover:bg-gray-100"
                onClick={() => {
                  if (typeof window !== 'undefined' && window.gtag) {
                    window.gtag('event', 'cta_clicked', {
                      event_category: 'engagement',
                      event_label: 'view_services_hero',
                      value: 1,
                    })
                  }
                }}
              >
                Our Services
              </Button>
            </div>
          </MotionDiv>
        </div>
      </Container>
    </div>
  )
}

